var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"oral-location-image-container\">\n<img ng-src=\"{{ $ctrl.location|locationImage:'medium' }}\"/>\n</div>\n<p>{{$ctrl.location.address.street}} {{$ctrl.location.address.postal_code}}<br/>\n{{$ctrl.location.address.postal_area}}\n</p>\n<p><span translate>Vastaanotto</span> {{$ctrl.location.phone}}<br/><span translate>Sähköposti</span> {{$ctrl.location.email}}</p>\n";
var id1="app/next-times/next-times-location-info.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;